import React from "react";

import Tab from '../Tab';

import {
    Title,
    Container,
    TabContainer
} from "./styles";

interface TabCardGroupProps {
    children: React.ReactNode;
    title?: string;
    titles?: string[];
    noPadding?: boolean;
    gridColumnsOnMobile?: 1 | 2;
}

export default function TabCardGroup( { 
    children,
    title,
    titles,
    noPadding = false,
    gridColumnsOnMobile = 1
}: TabCardGroupProps ) {
    return (
        <Container noPadding={noPadding}>
            { title && <Title>{ title }</Title> }
            { titles && <Tab titles={titles} /> }
            <TabContainer gridColumnsOnMobile={gridColumnsOnMobile}>
                { children}
            </TabContainer>
        </Container>
    )
}